module.exports = __webpack_public_path__ + "static/283-0509c96c5bc7429de63da2e8a3bcac7c.png";